import axios from 'axios'
import { GET_HOST, SET_HOST } from './constants'

export const login = async (environment, email, password) => {

    // var salt = bcrypt.genSaltSync(5);
    // var hash = bcrypt.hashSync(password, salt);

    SET_HOST(environment)

    const response = await axios.post('admin-wvivu-login', {
        email,
        password
    },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            }
        })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const logout = async (token) => {

    GET_HOST()

    const response = await axios.post('admin-wvivu-logout', {}, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            Authorization: token
        }
    })

    if (response && response.status === 200) {
        return response.data.token || ''
    }
    return ''
}

export const checkToken = async (token) => {
    try {
        GET_HOST()

        const response = await axios.post('admin-wvivu-check-token', {}, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                Authorization: token
            }
        })

        if (response && response.status === 200) {
            return response.data || null
        }
        return null
    } catch (error) {
        return null
    }
}
